/* ==========================================================================
   VJ-CORR-D98/D99/D100 — 28 août 2026 — LE CERTIFICAT SUIT SON ARTICLE
   --------------------------------------------------------------------------
   Rachid, le 28 août, trois remarques sur la même pièce :

     D98  « sur le panier il te le met à part, pas relié à l'article acheté.
            Donc si après par exemple y'a 2 articles, tu ne sais pas lequel
            est avec certificat dans le panier »
     D99  « si tu décides de l'enlever après du panier, il reste jaune sur la
            page de l'article, tu ne peux plus le remettre »
     D100 « tu peux te retrouver avec uniquement un certificat entropy dans le
            panier sans article »

   LA CAUSE COMMUNE, ET ELLE EST UNE SEULE. `snippets/vj-entrupy.liquid`
   (D77, 20 août) ajoutait le certificat par un `/cart/add.js` nu :
   `{ items: [{ id: variante, quantity: 1 }] }`. Aucune propriété de ligne,
   donc aucun lien vers l'article (D98). L'état du bouton n'était relu qu'à
   l'ouverture de la page et après un ajout réussi, jamais après un retrait,
   parce que le retrait se fait AILLEURS — dans le tiroir, sur la page panier —
   et que rien ne revenait le dire à la fiche (D99). Et rien n'interdisait
   d'encaisser une authentification sans objet à authentifier (D100).

   POURQUOI UN FICHIER À PART, ET CHARGÉ PARTOUT. Le tiroir de panier
   (`wdt-cart-drawer`) est rendu sur les HUIT pages par `layout/theme.liquid`.
   Un client peut donc retirer le certificat depuis n'importe où. Un garde-fou
   qui ne vivrait que dans la fiche produit — là où D77 avait posé son script —
   serait aveugle partout ailleurs. C'est la leçon du 22 août : « un correctif
   posé dans une section invisible n'existe pas ».

   CE QUE CE FICHIER NE FAIT PAS, ET C'EST VOULU
   · il n'écrit jamais dans `config/settings_data.json` (règle 1.1) ;
   · il ne remplace pas le panier du thème : il se BRANCHE dessus. Les points
     d'accroche `window.fetchCart` et `window.showCartDrawer` sont ceux de
     `snippets/ajax-cart.liquid` (lignes 81-85), déjà utilisés par D77 ;
   · il ne retire jamais un ARTICLE. Il ne retire qu'une option devenue sans
     objet, et il le DIT — retirer en silence une ligne payante serait pire
     que le défaut qu'on corrige.

   ROLLBACK : supprimer ce fichier, retirer sa balise `<script>` de
   `layout/theme.liquid` (marqueurs VJ-CORR-D98), et rétablir le corps du
   `<script>` de `snippets/vj-entrupy.liquid` dans sa version D77.
   ========================================================================== */
(function () {
  'use strict';

  /* Le handle est la clé, pas le titre : le titre est éditable en admin et
     changerait le comportement du site sans qu'on le sache. */
  var HANDLE = 'certificat-entrupy';
  var PROP_PARENT = '_vj_pour_variante';
  var PROP_VISIBLE = 'Certificat pour';

  var enCours = false;      /* le garde-fou ne doit pas se déclencher sur ses propres écritures */
  var dernierEtat = null;

  var estCertificat = function (i) {
    if (!i) return false;
    if (i.handle === HANDLE) return true;
    return typeof i.url === 'string' && i.url.indexOf('/products/' + HANDLE) !== -1;
  };

  var lire = function () {
    return fetch('/cart.js', { cache: 'no-store', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); });
  };

  /* ------------------------------------------------------------------------
     D100 — LE GARDE-FOU. Trois règles, dans cet ordre.
     ------------------------------------------------------------------------ */
  var garder = function (panier) {
    var articles = panier.items.filter(function (i) { return !estCertificat(i); });
    var certificats = panier.items.filter(estCertificat);
    if (!certificats.length) return Promise.resolve({ panier: panier, retires: [] });

    var changements = [];
    var retires = [];

    certificats.forEach(function (c) {
      var parent = (c.properties || {})[PROP_PARENT];

      /* 1. Le certificat nomme un article : cet article doit être au panier. */
      if (parent) {
        var vivant = articles.filter(function (a) { return String(a.variant_id) === String(parent); })[0];
        if (!vivant) {
          changements.push({ id: c.key, quantity: 0 });
          retires.push(((c.properties || {})[PROP_VISIBLE] || c.product_title));
          return;
        }
        /* 3. Une authentification par exemplaire, pas plus : on ne vend pas
           trois certificats pour un sac. On plafonne SUR la quantité du
           parent plutôt que sur 1, parce que deux exemplaires du même article
           méritent deux certificats. */
        if (c.quantity > vivant.quantity) {
          changements.push({ id: c.key, quantity: vivant.quantity });
        }
        return;
      }

      /* 2. Certificat sans parent — une ligne posée avant ce correctif, ou
         ajoutée sur un panier vide. Il ne peut rester QUE s'il reste au moins
         un article à authentifier. */
      if (!articles.length) {
        changements.push({ id: c.key, quantity: 0 });
        retires.push(c.product_title);
      }
    });

    if (!changements.length) return Promise.resolve({ panier: panier, retires: [] });

    enCours = true;
    var suite = Promise.resolve(panier);
    changements.forEach(function (ch) {
      suite = suite.then(function () {
        return fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(ch),
        }).then(function (r) { return r.json(); });
      });
    });
    return suite
      .then(function (dernier) { return { panier: dernier, retires: retires }; })
      .catch(function () { return { panier: panier, retires: [] }; })
      .then(function (res) { enCours = false; return res; });
  };

  /* ------------------------------------------------------------------------
     LE MESSAGE. On ne retire pas une ligne payante en silence.
     ------------------------------------------------------------------------ */
  var annoncer = function (retires) {
    if (!retires.length) return;
    var texte = retires.length === 1
      ? 'Le certificat d’authentification a été retiré en même temps que son article.'
      : 'Les certificats d’authentification ont été retirés en même temps que leurs articles.';

    var hote = document.querySelector('#cart-items-list')
      || document.querySelector('.cart-items-list')
      || document.querySelector('.main-card')
      || document.querySelector('#main-cart-items');
    if (!hote) return;

    var vieux = document.querySelector('.vj-panier-avis');
    if (vieux) vieux.remove();

    var p = document.createElement('p');
    p.className = 'vj-panier-avis';
    p.setAttribute('role', 'status');
    p.textContent = texte;
    hote.insertBefore(p, hote.firstChild);
    setTimeout(function () { if (p.parentNode) p.remove(); }, 9000);
  };

  /* ------------------------------------------------------------------------
     LA SYNCHRONISATION. Après toute écriture sur le panier, d'où qu'elle
     vienne, on relit, on garde, et on prévient la page.
     ------------------------------------------------------------------------ */
  var minuteur = null;
  var synchroniser = function (raison) {
    if (enCours) return;
    clearTimeout(minuteur);
    minuteur = setTimeout(function () {
      lire().then(function (panier) {
        return garder(panier).then(function (res) {
          dernierEtat = res.panier;
          if (res.retires.length) {
            /* Le rendu affiché est devenu faux : on le refait par le point
               d'accroche du thème quand il existe, sinon on recharge — mais
               seulement sur la page panier, où l'écart se verrait. */
            if (typeof window.fetchCart === 'function') {
              try { window.fetchCart(); } catch (e) {}
            }
            annoncer(res.retires);
            if (/\/cart(\/|$|\?)/.test(location.pathname) && typeof window.fetchCart !== 'function') {
              location.reload();
              return;
            }
          }
          document.dispatchEvent(new CustomEvent('vj:panier', {
            detail: { panier: res.panier, retires: res.retires, raison: raison || '' },
          }));
          /* VJ-CORR-D106 : le thème vient peut-être de reconstruire la liste
             par `innerHTML` ; on remet les options sous leur article. Deux
             passes, parce que `fetchCart()` est asynchrone et que la seconde
             attrape le rendu qui n'était pas encore posé à la première. */
          if (typeof rangerLesOptions === 'function') {
            rangerLesOptions();
            setTimeout(rangerLesOptions, 350);
          }
        });
      }).catch(function () {});
    }, 180);
  };

  /* ------------------------------------------------------------------------
     VJ-CORR-D106-DEBUT — 2 septembre 2026 — LA LIGNE DU CERTIFICAT REJOINT
     LA SIENNE, SUR LA PAGE PANIER.

     Le tiroir est traité au RENDU (`groupNestedItems`, snippets/ajax-cart.liquid).
     La page panier, elle, est rendue par Liquid et l'ordre y est celui de
     `cart.items` — c'est-à-dire, mesuré au curl le 2 septembre, la ligne la
     plus récente EN PREMIER. Le certificat sort donc en tête et son article
     en queue.

     POURQUOI ON DÉPLACE LE NŒUD AU LIEU DE TRIER EN LIQUID. `forloop.index`
     EST le numéro de ligne Shopify : il part dans les dix `data-line` de la
     boucle et dans les deux `cart_change_url?line=`. Réordonner la boucle
     décalerait chaque quantité et chaque suppression d'un cran — le
     commentaire de `main-cart.liquid` le disait déjà, il avait raison.
     Un `after()` ne change rien à tout cela : `data-line` et `id` voyagent
     AVEC le nœud, les écouteurs sont attachés aux éléments eux-mêmes,
     `updateCart` retrouve sa cible par `data-line` et par l'identifiant, et
     `data.items[line - 1]` lit le panier SERVEUR, dont l'ordre n'est pas
     touché.

     L'ANCRE. La valeur de `_vj_pour_variante` arrive par `data-vj-pour`
     (posé par D106 dans le gabarit). L'article correspondant se retrouve par
     `input[name="updates[<id de variante>]"]` — le SEUL endroit du DOM de
     cette page qui porte un id de variante, vérifié sur le HTML servi.

     On rejoue à chaque fois : `updateCart` fait un `location.reload()` à
     quantité 0, et le thème reconstruit la liste par `innerHTML`.
     ------------------------------------------------------------------------ */
  var rangerLesOptions = function () {
    var lignes = document.querySelectorAll('[data-vj-pour]');
    if (!lignes.length) return 0;
    var deplacees = 0;
    Array.prototype.forEach.call(lignes, function (ligne) {
      var idParent = ligne.getAttribute('data-vj-pour');
      if (!idParent) return;
      var champ = document.querySelector('input[name="updates[' + idParent + ']"]');
      if (!champ) return;                       /* l'article n'est plus là : le garde-fou s'en occupe */
      var parente = champ.closest('.card-information');
      if (!parente || parente === ligne) return;
      if (parente.nextElementSibling === ligne) {
        ligne.classList.add('vj-ligne-option--rangee');
        parente.classList.add('vj-ligne-a-option');
        return;                                  /* déjà en place, on ne touche pas au DOM pour rien */
      }
      parente.after(ligne);
      ligne.classList.add('vj-ligne-option--rangee');
      parente.classList.add('vj-ligne-a-option');
      deplacees++;
    });
    return deplacees;
  };
  /* VJ-CORR-D106-FIN */

  /* ------------------------------------------------------------------------
     VJ-CORR-D276-DEBUT — 12 septembre 2026 — LE CERTIFICAT EST PROPOSÉ DANS LE
     TIROIR, ET IL N'EST PAS AJOUTÉ
     ------------------------------------------------------------------------
     Rachid : « une fois qu'il a ajouté, faire une proposition dans le panier
     d'ajout en groupé. Il faut que ça pop — qu'il soit PAS ajouté, mais qu'il
     soit PROPOSÉ dans le panier, tu comprends. Je sais que dans le catalogue
     c'est faisable, parce qu'une fois qu'on est sur le catalogue on a ajouté
     le certificat en option ; mais lorsqu'on appuie sur un article, il n'est
     pas proposé au niveau du panier. »

     Il a raison sur les deux points. L'option n'existait QUE sur la fiche
     produit (`snippets/vj-entrupy.liquid`, D77) : un client qui ajoute depuis
     une vignette de rail ou depuis le catalogue ne la voit jamais. Et le
     réglage `settings.cart_upsell_enable` du thème Bera — la seule mécanique
     de proposition du tiroir — n'est pas activé, donc le bloc d'upsell n'est
     même pas rendu ; il proposerait de toute façon des PIÈCES, ce qui n'a
     aucun sens quand chaque pièce est unique.

     CE QUE CE BLOC FAIT, ET CE QU'IL NE FAIT PAS
     · il PROPOSE, il n'ajoute jamais de lui-même. C'est la demande, mot pour
       mot, et c'est aussi la règle de la maison : on n'encaisse rien que le
       client n'a pas demandé.
     · il réutilise EXACTEMENT le lien de D98 — `_vj_pour_variante` porte
       l'identifiant de variante de l'article, `Certificat pour` porte son
       titre. Le garde-fou D100 continue donc de retirer le certificat si son
       article s'en va, et la fiche produit continue d'afficher le bon état :
       une seule mécanique, deux portes d'entrée.
     · il ne propose rien s'il n'y a rien à proposer — pas d'article nu, pas
       de certificat en stock, pas de produit `certificat-entrupy`. Une carte
       creuse serait pire que pas de carte.
     · il ne propose QUE pour le premier article nu, et il le NOMME. Une liste
       de propositions dans un tiroir est un catalogue, pas une proposition.

     La fiche du certificat est lue UNE fois et gardée : le tiroir se reconstruit
     à chaque écriture sur le panier, et retirer la même fiche à chaque rendu
     serait un appel réseau par clic.
     ------------------------------------------------------------------------ */
  var CERT = null;           /* la fiche produit, une fois lue */
  var certEnVol = null;

  var lireCertificat = function () {
    if (CERT) return Promise.resolve(CERT);
    if (certEnVol) return certEnVol;
    certEnVol = fetch('/products/' + HANDLE + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (p) {
        if (!p) return null;
        var v = (p.variants || []).filter(function (x) { return x.available; })[0];
        if (!v) return null;
        CERT = { id: v.id, prix: v.price, titre: p.title };
        return CERT;
      })
      .catch(function () { return null; });
    return certEnVol;
  };

  /* VJ-CORR-D617 — 8 octobre 2026 — LES MONTANTS DU PANIER DANS LA MONNAIE DU CLIENT.
     `sou` et `prixRond` écrivaient l'euro en dur : un panier suisse (CHF depuis le 8 octobre)
     affichait ses mensualités « 62,00 € » et l'offre Entrupy en euros. Hors de l'euro, le
     montant prend le format de Shopify (wdtTheme.moneyFormat, D616 : « CHF {{amount}} »), celui
     du rendu serveur. En euros, le code d'avant, INCHANGÉ. */
  var vjDevise = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'EUR';
  var vjFormat = function (centimes) {
    var f = (window.wdtTheme && window.wdtTheme.moneyFormat) || ('{{amount}} ' + vjDevise);
    var n = centimes / 100;
    var milliers = function (ent, sep) { return ent.replace(/\B(?=(\d{3})+(?!\d))/g, sep); };
    var deux = function (dec, mil) { var x = n.toFixed(2).split('.'); return milliers(x[0], mil) + dec + x[1]; };
    return f.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, k) {
      if (k === 'amount_no_decimals') return milliers(String(Math.round(n)), ',');
      if (k === 'amount_with_comma_separator') return deux(',', '.');
      if (k === 'amount_no_decimals_with_comma_separator') return milliers(String(Math.round(n)), '.');
      if (k === 'amount_with_apostrophe_separator') return deux('.', "'");
      return deux('.', ',');
    });
  };

  var sou = function (centimes) {
    if (vjDevise !== 'EUR') return vjFormat(centimes);
    try {
      return (centimes / 100).toLocaleString('fr-FR', {
        style: 'currency', currency: 'EUR', minimumFractionDigits: 2,
      });
    } catch (e) { return (centimes / 100).toFixed(2) + ' €'; }
  };

  /* ------------------------------------------------------------------------
     VJ-CORR-D380 — 16 septembre 2026 (vingtième tour) — UNE AUTHENTIFICATION
     PAR PIÈCE, SOUS LA PIÈCE, ET SEULEMENT POUR CE QU'ENTRUPY AUTHENTIFIE
     ------------------------------------------------------------------------
     Rachid : « si je sélectionne un sac, puis un deuxième sac, il doit y avoir
     deux Entrupy qui apparaissent et non pas un […] c'est un Entrupy produit. »
     Et : « les Entrupy n'apparaissent que sur du sac et de la petite
     maroquinerie — sac, portefeuille, pochette ; foulards, boucles d'oreilles,
     l'Entrupy n'est pas valable. »

     D276 ne proposait QUE pour la première pièce nue, en une rangée posée
     après la liste : avec deux sacs, une seule offre à l'écran. Et elle
     proposait pour TOUT article, foulard et bijou compris.

     CE QUI CHANGE
     · chaque pièce authentifiable et nue reçoit SA rangée, posée juste sous
       elle (tiroir : `#CartItem-<clé>` ; page panier : la `.card-information`
       qui porte `updates[<variante>]`, la même ancre que D106). Deux sacs,
       deux rangées ; l'ajout d'un certificat retire la rangée de SA pièce et
       laisse l'autre ;
     · la rangée garde le dessin validé de D323, au pixel ;
     · l'éligibilité se lit sur le TYPE de produit (`product_type` du panier).
       La liste vit en UN endroit, `snippets/vj-entrupy-types.liquid`, rendue
       dans `window.VJ_ENTRUPY_TYPES` par layout/theme.liquid et lue aussi par
       l'encart de la fiche (`snippets/vj-entrupy.liquid`).

     CE QUI NE CHANGE PAS : l'écriture (`/cart/add.js`, `_vj_pour_variante`),
     le garde-fou D100, le rechargement de /cart de D314. Rien n'est proposé
     s'il n'y a pas de fiche `certificat-entrupy` en stock.
     ------------------------------------------------------------------------ */
  var TYPES_AUTHENTIFIABLES = (window.VJ_ENTRUPY_TYPES && window.VJ_ENTRUPY_TYPES.length)
    ? window.VJ_ENTRUPY_TYPES
    : ['Sacs', 'Petite maroquinerie'];
  var authentifiable = function (i) {
    return TYPES_AUTHENTIFIABLES.indexOf(String(i.product_type || '').trim()) !== -1;
  };

  /* LES PIÈCES À PROPOSER : authentifiables, et sans leur certificat. */
  var articlesNus = function (panier) {
    var items = (panier && panier.items) || [];
    var certs = items.filter(estCertificat);
    var couverts = {};
    certs.forEach(function (c) {
      var p = (c.properties || {})[PROP_PARENT];
      if (p) couverts[String(p)] = true;
    });
    /* un certificat sans parent est une ligne d'avant D98 : elle couvre le
       panier entier, faute de savoir ce qu'elle authentifie. */
    if (certs.some(function (c) { return !(c.properties || {})[PROP_PARENT]; })) return [];
    return items.filter(function (i) {
      return !estCertificat(i) && authentifiable(i) && !couverts[String(i.variant_id)];
    });
  };

  /* VJ-CORR-D298 — l'offre vit dans le tiroir ET sur la page panier : sur
     /cart le tiroir existe mais n'est pas ouvert. */
  var racinesPanier = function () {
    var r = [];
    var tiroir = document.getElementById('cartOffCanvas');
    if (tiroir) r.push(tiroir);
    var page = document.getElementById('cart-form') ||
               document.querySelector('#MainContent .cart-container');
    if (page) r.push(page);
    return r;
  };

  var poserProposition = function (panier) {
    racinesPanier().forEach(function (racine) { poserDans(racine, panier); });
  };

  var prixRond = function (centimes) {
    if (vjDevise !== 'EUR') return vjFormat(centimes);
    if (centimes % 100 !== 0) return sou(centimes);
    try {
      return (centimes / 100).toLocaleString('fr-FR', {
        style: 'currency', currency: 'EUR', minimumFractionDigits: 0, maximumFractionDigits: 0,
      });
    } catch (e) { return (centimes / 100) + ' €'; }
  };

  var brancherAjout = function (bouton, cert, article) {
    bouton.addEventListener('click', function () {
      if (bouton.disabled) return;
      bouton.disabled = true;
      var avant = bouton.innerHTML;
      bouton.textContent = 'Ajout…';
      var props = {};
      props[PROP_VISIBLE] = article.product_title;
      props[PROP_PARENT] = String(article.variant_id);
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: cert.id, quantity: 1, properties: props }] }),
      }).then(function (r) {
        if (!r.ok) throw new Error('refus');
        /* VJ-CORR-D314 : sur /cart, `fetchCart()` ne repeint que le tiroir ;
           une page panier rechargée est juste partout. */
        if (/\/cart(\/|$|\?)/.test(location.pathname)) { location.reload(); return; }
        if (typeof window.fetchCart === 'function') { window.fetchCart(); }
      }).catch(function () {
        bouton.innerHTML = avant;
        bouton.disabled = false;
      });
    });
  };

  /* L'ANCRE D'UNE PIÈCE. Le tiroir nomme ses lignes par la CLÉ de ligne
     (`#CartItem-<clé>`, ajax-cart.liquid) ; la page panier ne porte l'id de
     variante qu'au champ `updates[<id>]` (D106) — §5.2 unquinquagies. */
  var ancreDe = function (racine, article) {
    if (racine.id === 'cartOffCanvas') {
      var ligne = document.getElementById('CartItem-' + article.key);
      return ligne && racine.contains(ligne) ? ligne : null;
    }
    var champ = racine.querySelector('input[name="updates[' + article.id + ']"]') ||
                racine.querySelector('input[name="updates[' + article.variant_id + ']"]');
    return champ ? champ.closest('.card-information') : null;
  };

  var rangee = function (cert, article) {
    /* VJ-CORR-D323 — la rangée validée : [logo][Authentification Entrupy
       disponible à 25 €][Ajouter]. Le titre de la pièce vit dans le nom
       accessible du bouton, APRÈS le mot visible (§5.2 quintricies bis), et
       il est écrit en TEXTE : il vient de la boutique. */
    var boite = document.createElement('div');
    boite.className = 'vj-offre-cert vj-offre-cert--piece';
    boite.setAttribute('data-pour', String(article.variant_id));
    boite.innerHTML =
      '<span class="vj-offre-cert__marque" aria-hidden="true"></span>' +
      '<p class="vj-offre-cert__mot">' +
        '<span class="vj-offre-cert__titre">Authentification Entrupy</span> ' +
        '<span class="vj-offre-cert__texte">disponible à ' + prixRond(cert.prix) + '</span>' +
      '</p>' +
      '<button type="button" class="vj-offre-cert__bouton">Ajouter<span class="visually-hidden vj-offre-cert__pour"></span></button>';
    boite.querySelector('.vj-offre-cert__pour').textContent =
      ' l’authentification Entrupy pour ' + article.product_title;
    brancherAjout(boite.querySelector('.vj-offre-cert__bouton'), cert, article);
    return boite;
  };

  var offresVues = {};
  /* VJ-CORR-D503 — le certificat est lu DÈS le chargement de la page : à
     l'ajout d'une pièce, l'offre ne l'attend plus (elle arrivait ~430 ms après
     l'article, relevé au film). */
  if (window.requestIdleCallback) window.requestIdleCallback(function () { lireCertificat(); }, { timeout: 2500 });
  else window.setTimeout(function () { lireCertificat(); }, 1200);

  var poserDans = function (racine, panier) {
    if (!racine) return;
    var nus = articlesNus(panier);
    var voulues = {};
    nus.forEach(function (a) { voulues[String(a.variant_id)] = true; });

    /* on retire d'abord ce qui n'a plus d'objet — la rangée d'une pièce
       couverte, retirée ou non authentifiable */
    Array.prototype.forEach.call(racine.querySelectorAll('.vj-offre-cert'), function (b) {
      if (!voulues[b.getAttribute('data-pour') || '']) b.remove();
    });
    if (!nus.length) return;

    lireCertificat().then(function (cert) {
      if (!cert) {
        Array.prototype.forEach.call(racine.querySelectorAll('.vj-offre-cert'), function (b) { b.remove(); });
        return;
      }
      nus.forEach(function (article) {
        var ancre = ancreDe(racine, article);
        var id = String(article.variant_id);
        var deja = Array.prototype.filter.call(racine.querySelectorAll('.vj-offre-cert'), function (b) {
          return b.getAttribute('data-pour') === id;
        });
        if (!ancre) { deja.forEach(function (b) { b.remove(); }); return; }
        /* déjà posée, et au bon endroit : on ne refait pas le DOM — un nœud
           reconstruit à chaque rendu perd le focus du clavier */
        if (deja.length === 1 && ancre.nextElementSibling === deja[0]) return;
        deja.forEach(function (b) { b.remove(); });
        var neuve = rangee(cert, article);
        /* VJ-CORR-D503 — la première apparition d'une offre ENTRE (fondu et
           glissé de 8 px) au lieu de surgir ; un nouveau rendu du tiroir
           (quantité, autre ajout) la repose sans la rejouer. */
        if (!offresVues[id]) { neuve.classList.add('vj-offre-cert--entre'); offresVues[id] = true; }
        ancre.parentNode.insertBefore(neuve, ancre.nextSibling);
      });
    });
  };

  document.addEventListener('vj:panier', function (e) {
    poserProposition(e.detail && e.detail.panier);
  });
  /* VJ-CORR-D503 — LE TIROIR RÉÉCRIT, L'OFFRE REPOSÉE DANS LA MÊME IMAGE.
     Au film (80 ms) : l'offre posée à 1 061 ms, EFFACÉE à 1 144 ms par une
     seconde réécriture du tiroir (`innerHTML` du thème), reposée à 1 278 ms
     au `vj:panier` suivant — un clignotement. Un observateur de mutations
     rappelle la pose dès la réécriture ; ses rappels passent en micro-tâche,
     et le certificat est déjà en cache : la pose a lieu AVANT l'affichage.
     Une pose qui trouve l'offre en place ne touche à rien (pas de boucle). */
  (function () {
    var tiroirP = document.getElementById('cartOffCanvas');
    if (!tiroirP || !window.MutationObserver) return;
    var enPose = false;
    new MutationObserver(function () {
      if (enPose || !dernierEtat || !CERT) return;
      if (!tiroirP.querySelector('.cart-item')) return;
      enPose = true;
      try { poserDans(tiroirP, dernierEtat); } catch (e) {}
      window.setTimeout(function () { enPose = false; }, 0);
    }).observe(tiroirP, { childList: true, subtree: true });
  })();
  /* Le tiroir s'ouvre sans qu'on ait forcément écrit sur le panier (clic sur
     l'icône) : on repose l'offre à l'ouverture, avec l'état déjà connu. */
  document.addEventListener('shown.bs.offcanvas', function (e) {
    if (e.target && e.target.id === 'cartOffCanvas') poserProposition(dernierEtat);
  }, true);
  /* VJ-CORR-D298 — sur /cart, aucun tiroir ne s'ouvre et rien n'ecrit sur le
     panier : sans ce premier appel, l'offre n'apparaitrait qu'apres une
     modification. On lit l'etat une fois, au chargement. Le rendu du theme est
     asynchrone (`fetchCart`), d'ou la seconde passe — meme raison que D106. */
  var amorcerPagePanier = function () {
    if (!document.getElementById('cart-form')) return;
    lire().then(function (panier) {
      dernierEtat = panier;
      poserProposition(panier);
      setTimeout(function () { poserProposition(dernierEtat); }, 500);
    }).catch(function () {});
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', amorcerPagePanier);
  } else {
    amorcerPagePanier();
  }

  /* VJ-CORR-D380 — LES RANGÉES VIVENT ENTRE LES ARTICLES, ET LE THÈME
     RECONSTRUIT LA LISTE PAR `innerHTML` (ajax-cart.liquid, à l'ouverture
     comme après chaque écriture) : mesuré, les deux rangées posées au
     `shown.bs.offcanvas` étaient effacées dans la seconde. D276 posait sa
     rangée APRÈS la liste, hors de portée de la reconstruction ; la nôtre est
     dedans. On observe donc la racine — elle, stable — et on repose. Converge :
     `poserDans` ne touche au DOM que si une rangée manque ou n'est pas à sa
     place. */
  var observerRacines = function () {
    racinesPanier().forEach(function (racine) {
      if (racine.dataset.vjOffreObs || !window.MutationObserver) return;
      racine.dataset.vjOffreObs = '1';
      var minute = null;
      new MutationObserver(function (mutations) {
        var siennes = mutations.every(function (m) {
          var noeuds = Array.prototype.slice.call(m.addedNodes).concat(Array.prototype.slice.call(m.removedNodes));
          return noeuds.length && noeuds.every(function (n) {
            return n.nodeType === 1 && n.classList && n.classList.contains('vj-offre-cert');
          });
        });
        if (siennes || !dernierEtat) return;
        clearTimeout(minute);
        minute = setTimeout(function () { poserDans(racine, dernierEtat); }, 120);
      }).observe(racine, { childList: true, subtree: true });
    });
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', observerRacines);
  } else {
    observerRacines();
  }
  /* VJ-CORR-D276-FIN */

  /* ------------------------------------------------------------------------
     VJ-CORR-D313-DEBUT — 13 septembre 2026 — LES MONTANTS DU PAIEMENT EN
     PLUSIEURS FOIS SUIVENT LE PANIER
     ------------------------------------------------------------------------
     La coquille est rendue par `snippets/vj-panier-fractionne.liquid` — c'est
     elle qui porte les VRAIS logos PayPal et Klarna, servis par Shopify. Mais
     le total du panier change à chaque ajout, à chaque retrait, à chaque pas
     de quantité, et le tiroir ne recharge jamais la page : les deux montants
     ne peuvent pas être figés en Liquid.

     Les planchers sont ceux des fournisseurs, repris de D297 — 30 € pour le
     4 fois PayPal, 35 € pour le 3 fois Klarna, 2 000 € de plafond commun.
     Hors bornes, la ligne se retire ; hors des deux, le bloc entier disparaît.
     Annoncer « 4 × 6,25 € » sur un panier à 25 € serait faux, et le dossier
     interdit d'annoncer ce qu'on ne peut pas tenir.
     ------------------------------------------------------------------------ */
  var PFRAC_MIN4 = 3000;
  var PFRAC_MIN3 = 3500;
  var PFRAC_MAX = 200000;

  var peindreFractionne = function (panier) {
    var blocs = document.querySelectorAll('[data-vj-pfrac]');
    if (!blocs.length) return;
    var total = (panier && panier.total_price) || 0;
    var ok4 = total >= PFRAC_MIN4 && total <= PFRAC_MAX;
    var ok3 = total >= PFRAC_MIN3 && total <= PFRAC_MAX;

    Array.prototype.forEach.call(blocs, function (b) {
      b.hidden = !(ok4 || ok3);
      var l4 = b.querySelector('[data-vj-pfrac-l4]');
      var l3 = b.querySelector('[data-vj-pfrac-l3]');
      var q4 = b.querySelector('[data-vj-pfrac-q4]');
      var q3 = b.querySelector('[data-vj-pfrac-q3]');
      if (l4) l4.hidden = !ok4;
      if (l3) l3.hidden = !ok3;
      /* division ENTIÈRE, comme le filtre `divided_by` de Liquid sur des
         entiers : les deux rendus doivent dire le même chiffre au centime. */
      if (q4) q4.textContent = sou(Math.floor(total / 4));
      if (q3) q3.textContent = sou(Math.floor(total / 3));
    });
  };

  document.addEventListener('vj:panier', function (e) {
    peindreFractionne(e.detail && e.detail.panier);
  });
  /* VJ-CORR-D313-FIN */

  window.vjPanier = {
    HANDLE: HANDLE,
    PROP_PARENT: PROP_PARENT,
    PROP_VISIBLE: PROP_VISIBLE,
    estCertificat: estCertificat,
    lire: lire,
    synchroniser: synchroniser,
    ranger: rangerLesOptions,
    dernier: function () { return dernierEtat; },
    /* D380 : exposés pour que l'épreuve exerce le code livré */
    articlesNus: articlesNus,
    proposer: poserProposition,
  };

  /* ------------------------------------------------------------------------
     LES MOUCHARDS. Le thème écrit sur le panier par `fetch` (ajax-cart) ET
     par `$.ajax` (jQuery, donc XMLHttpRequest) selon les chemins. On écoute
     les DEUX : n'en écouter qu'un laisse la moitié des retraits invisibles.
     ------------------------------------------------------------------------ */
  var ECRITURES = /\/cart\/(add|change|update|clear)(\.js)?/;

  if (window.fetch) {
    var fetchOrigine = window.fetch;
    window.fetch = function (entree, options) {
      var url = '';
      try { url = typeof entree === 'string' ? entree : (entree && entree.url) || ''; } catch (e) {}
      var ecrit = ECRITURES.test(url);
      return fetchOrigine.apply(this, arguments).then(function (r) {
        if (ecrit) synchroniser('fetch ' + url);
        return r;
      });
    };
  }

  if (window.XMLHttpRequest) {
    var ouvrir = XMLHttpRequest.prototype.open;
    XMLHttpRequest.prototype.open = function (methode, url) {
      try { this.__vjEcrit = ECRITURES.test(String(url)); } catch (e) {}
      return ouvrir.apply(this, arguments);
    };
    var envoyer = XMLHttpRequest.prototype.send;
    XMLHttpRequest.prototype.send = function () {
      var xhr = this;
      if (xhr.__vjEcrit) {
        xhr.addEventListener('loadend', function () { synchroniser('xhr'); });
      }
      return envoyer.apply(this, arguments);
    };
  }

  /* Retour arrière du navigateur : la page revient du cache mémoire avec un
     panier peut-être périmé. `pageshow` avec `persisted` est le seul signal. */
  window.addEventListener('pageshow', function (e) { synchroniser(e.persisted ? 'bfcache' : 'chargement'); });
  document.addEventListener('visibilitychange', function () {
    if (!document.hidden) synchroniser('onglet revenu');
  });

  /* VJ-CORR-D106 : on range AVANT le premier aller-retour réseau. `synchroniser`
     attend 180 ms puis lit `/cart.js` ; ranger seulement à son retour ferait
     voir la ligne sauter de place sous les yeux du client. Ici le déplacement
     a lieu dans le même rendu que la page. */
  var demarrer = function () {
    rangerLesOptions();
    synchroniser('DOM prêt');
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', demarrer);
  } else {
    demarrer();
  }

  /* ------------------------------------------------------------------
     VJ-CORR-D133 — 4 septembre 2026
     LE TIROIR OUVERT VERROUILLE LA PAGE DERRIÈRE
     ------------------------------------------------------------------
     Rachid : « quand on a le panier et qu'on scrolle, c'est le site
     derrière qui scrolle et non ce qu'il y a dans le panier ».

     Deux causes, mesurées : `data-bs-scroll="true"` sur le tiroir
     (retiré dans snippets/wdt-cart-drawer.liquid) ET, dans
     assets/theme.js ligne 4562, un écouteur `shown.bs.offcanvas` qui
     remet `document.body.style.overflow = "auto"` et défait le verrou
     de Bootstrap. Retirer l'attribut seul ne suffisait pas : relevé
     après essai, `_config.scroll` valait bien false et le body restait
     à `overflow: auto`.

     On ne lutte pas contre cet écouteur, on le surclasse : le verrou
     est une CLASSE, et sa règle est en `!important` dans
     vj-premium.css — une déclaration de feuille bat un style en ligne,
     quel que soit l'ordre d'exécution des scripts.

     `position: fixed` et non `overflow: hidden` seul : Safari iOS
     ignore `overflow: hidden` sur le body pour le geste tactile, et
     Rachid est sur iPhone. On mémorise donc le défilement, on le pose
     en `top` négatif, et on le rend à la fermeture — aucun saut.

     Le voile de bas de liste n'apparaît que s'il RESTE du contenu sous
     le pli. Un indice qui s'affiche quand il n'y a plus rien en dessous
     est pire que pas d'indice.

     Rollback : supprimer ce bloc et le bloc VJ-CORR-D133 de
     assets/vj-premium.css, et remettre l'attribut dans le snippet.
     ------------------------------------------------------------------ */
  var brancherLeVerrou = function () {
    var tiroir = document.getElementById('cartOffCanvas');
    if (!tiroir || tiroir.dataset.vjVerrou) return;
    tiroir.dataset.vjVerrou = '1';

    var memoire = 0;

    tiroir.addEventListener('show.bs.offcanvas', function () {
      memoire = window.scrollY || document.documentElement.scrollTop || 0;
      document.body.style.top = (-memoire) + 'px';
      document.documentElement.classList.add('vj-panier-verrou');
    });

    tiroir.addEventListener('hidden.bs.offcanvas', function () {
      /* VJ-CORR-D503 — 23 septembre 2026 — RENDRE LA POSITION D'UN COUP.
         Rachid : « dès qu'on ferme le panier, on a la page qui s'actualise
         et qui revient sur le produit qu'on a ajouté ». Aucune navigation
         (relevé tmp-r33-panier-geste.js) : `theme.css` pose
         `html { scroll-behavior: smooth }`, et ce `scrollTo` s'ANIMAIT depuis
         le haut de la page (le verrou y remet le document) jusqu'au produit —
         0 → 377 → 909 → 1 112 → 1 289 en 500 ms. On coupe l'animation le
         temps d'un retour instantané. */
      var html = document.documentElement;
      var avant = html.style.scrollBehavior;
      html.style.scrollBehavior = 'auto';
      html.classList.remove('vj-panier-verrou');
      document.body.style.top = '';
      try { window.scrollTo({ top: memoire, left: 0, behavior: 'instant' }); }
      catch (e) { window.scrollTo(0, memoire); }
      window.requestAnimationFrame(function () { html.style.scrollBehavior = avant; });
    });

    /* Le voile : allumé tant qu'il reste de la liste sous le pli. */
    var liste = tiroir.querySelector('.offcanvas-body');
    var majVoile = function () {
      if (!liste) return;
      var reste = liste.scrollHeight - liste.scrollTop - liste.clientHeight;
      tiroir.classList.toggle('vj-panier--suite', reste > 8);
    };
    if (liste) liste.addEventListener('scroll', majVoile, { passive: true });
    tiroir.addEventListener('shown.bs.offcanvas', function () { window.setTimeout(majVoile, 60); });
    window.addEventListener('resize', majVoile);
    /* Le contenu du tiroir est réécrit par ajax-cart.liquid à chaque
       ajout ou retrait : on ne peut pas se contenter des évènements
       d'ouverture. Un observateur coûte moins qu'un minuteur serré. */
    if (liste && window.MutationObserver) {
      new MutationObserver(function () { window.setTimeout(majVoile, 60); })
        .observe(liste, { childList: true, subtree: true });
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', brancherLeVerrou);
  } else {
    brancherLeVerrou();
  }
})();
